<!--suppress CheckEmptyScriptTag, HtmlFormInputWithoutLabel -->
<template>
  <div class="splash location-options">
    <NavBar class="navbarcontainer" titleTranslationPath="locationOptions.navBar.title" back />
    <div class="backdrop" />
    <div class="content">
      <div class="search">
        <div class="search-box">
          <font-awesome-icon icon="search" class="search-box-icon" />
          <input
            type="text"
            class="location-search-input"
            :placeholder="translate('locationOptions.search.input.placeholder')"
            v-model="query"
          />
        </div>
        <div class="search-sort" @click="openSorting">
          <font-awesome-icon icon="filter" class="filter-icon" />
        </div>
      </div>
      <div class="acknowledgement">
        <CheckboxField
          label="locationOptions.filter.onlyAcknowledgement"
          v-model="onlyAccepted"
          :has-info="true"
          @info-click="$router.push({ name: $namedRoutes.acceptedCommuneInfo })"
        />
      </div>
      <div class="region-selector">
        <SelectField
            identifier="region-selector"
            label="locationOptions.region.select"
            v-model="currentRegion"
            :options="regionOptions"
            :is-mandatory="false"
          >
        </SelectField>
      </div>
      <div class="locations">
        <div v-if="onlyAccepted && sortedLocations.length === 0" class="locations-entry">
          <NewTranslation path="locationOptions.filter.acknowledgement.selectCommuneFirst" />
        </div>
        <router-link
          :to="{ name: $namedRoutes.splash, params: { communeId: commune.id } }"
          v-for="commune in sortedLocations"
          class="locations-entry"
          :key="commune.id"
        >
          <div
            @click="selectLocation(commune)"
            v-bind:class="{
              selected: currentLocation && currentLocation.id === commune.id,
              partner: commune.isTaxCollectPartner,
            }"
          >
            {{ commune.title }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '@/components/NavBar.vue';
import i18next from 'i18next';
import CheckboxField from '@/components/form/CheckboxField';
import NewTranslation from '@/components/i18n/NewTranslation';
import SelectField from '../form/SelectField.vue';

export default {
  components: {
    NewTranslation,
    CheckboxField,
    NavBar,
    SelectField
  },
  data() {
    return {
      query: '',
      sortBy: 'alphabetical',
      onlyAccepted: false,
      acceptedLocations: [],
      currentRegion: 'none'
    };
  },
  async created() {
    const acceptedLocations = await this.$store.dispatch('acceptedCommunes');
    if (this.currentLocation) {
      acceptedLocations.push(this.currentLocation);
    }
    this.acceptedLocations = acceptedLocations.filter(commune => !!commune);
  },
  computed: {
    regionOptions() {
      return [
        { value: 'none', label: i18next.t('locationOptions.option.none') },
        { value: 'Vogtland', label: 'Vogtland'}
      ];
    },
    displayLocations() {
      if (this.onlyAccepted) {
        return this.acceptedLocations;
      }

      return this.locations;
    },
    filteredLocations() {
      const q = this.query.trim().toLowerCase();
      return this.displayLocations.filter(commune => {
        const matchesName = commune.title && commune.title.toLowerCase().includes(q);
        const matchesZip = commune.authorityZip && commune.authorityZip.includes(q);
        return matchesName || matchesZip;
      });
    },
    sortedLocations() {
      let resultLocations;
      if (this.sortBy === 'alphabetical' || this.sortBy === 'alphabetical-reverse') {
        const alphabetical = this.filteredLocations.sort((a, b) => {
          const nameA = a.title.toLowerCase();
          const nameB = b.title.toLowerCase();
          if (nameA < nameB) return -1;
          else if (nameA > nameB) return 1;
          else return 0;
        });
        resultLocations = this.sortBy === 'alphabetical-reverse' ? alphabetical.reverse() : alphabetical;
      } else {
        resultLocations = this.filteredLocations;
      }
      if (this.currentRegion !== 'none') {
        switch (this.currentRegion) {
          case 'Vogtland':
            return resultLocations.filter((element) => {
              if (element.id == 2301 || element.id == 2304 || element.id == 1685 || element.id == 2302 || element.id == 2297 || element.id == 2299 || element.id == 2298 || element.id == 2300 || element.id == 2307) {
                return true;
              }
              return false;
            });
            break;
          default:
            break;
        }
      }
      return resultLocations;
    },
    ...mapGetters(['locations', 'currentLocation']),
  },
  methods: {
    changeRegion(region) {
      //console.log("Region selected", region);
    },
    translate(path, params) {
      return i18next.t(path, params);
    },
    selectLocation(commune) {
      this.$store.commit('changeLocation', commune.id);
      this.$store.dispatch('loadCommuneData');
      return this.$route.params.splash;
    },
    openSorting() {
      const t = this.translate;
      this.$store.commit('openOverlay', {
        overlayName: 'Options',
        overlayData: {
          title: t('locationOptions.sort.title'),
          options: [
            {
              action: () => (this.sortBy = 'alphabetical'),
              value: t('locationOptions.sort.alphabetic.desc'),
            },
            {
              action: () => (this.sortBy = 'alphabetical-reverse'),
              value: t('locationOptions.sort.alphabetic.asc'),
            },
          ],
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-icon,
.search-box-icon {
  color: #454f63;
}
.search-box-icon {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
}
.filter-icon {
  margin: 10px 20px;
  font-size: 18px;
}
</style>

<style lang="sass" scoped>
.locations-entry
  color: #ff3a3a

.partner
  color: #2db92d

.selected
  color: #3497fd

.location-options
  overflow-x: scroll

.location-search-input
  margin-top: 0 !important
  border-radius: 10px !important

.splash
  height: 100vh
  background-image: url(../../assets/splash.png)
  display: flex
  flex-direction: column
  align-items: center
  color: #fff

.backdrop
  background-color: rgba(0, 0, 0, .5)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 1

.navbarcontainer
  z-index: 3

.content
  width: 100%
  z-index: 2
  padding: 0 20px

.acknowledgement
  margin-top: 15px
  height: 40px

.region-selector
  margin-top: 15px

.search
  margin-top: 15px
  height: 40px
  display: flex

  &-box
    position: relative
    border-radius: 10px
    background: #fff
    flex-grow: 1

  input
    border-radius: 10px
    height: 100%
    padding: 15px 15px 15px 50px
    font-size: 1rem
  &-sort
    width: 40px
    background-color: #fff
    border-radius: 10px
    margin-left: 10px
    color: #454F63
    display: flex
    justify-content: center
    align-items: center
.locations
  font-size: 1rem
  margin-top: 20px

  &-entry
    padding: 15px 0
    display: block

    & + .locations-entry
      border-top: 1px solid #fff
</style>
